import styled from "styled-components";

export const EducationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 140px 0 20px 0;
  @media screen and (max-width: 960px) {
    padding: 160px 0 20px 0;
  }
`;

export const EducationTitle = styled.h1`
  text-align: center;

  color: ${({ light }) => (light ? " #272727" : " #f7f8fa")};
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  font-family: Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif;
  letter-spacing: 1.5px;
  font-size: 40px;
`;

export const EducationWrapper = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 340px);
  gap: 20px;
  padding: 20px;
  justify-content: center;

  @media screen and (max-width: 320px) {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, 300px);
    gap: 20px;
    justify-content: center;
  }
`;

export const EducationCard = styled.div`
  background-color: ${({ light }) => (light ? " #272727" : " #transparent")};
  margin-bottom: 20px;
  border: 2px solid #497e76;
`;

export const EducationCardImg = styled.img`
  width: 100%;
  &:hover {
    transform: rotate(1turn);
    transition: all 0.4s ease-out;
  }
`;

export const ImgWrapper = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
  border-bottom: 4px solid #8ae0db;
  align-items: center;
  justify-content: center;
  background-color: #80c4f9;
`;

export const EducationCardMeta = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  margin-top: 2rem;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 2rem;
`;

export const EducationCardTitle = styled.h1`
  font-size: 18px;
  text-align: center;
  color: ${({ light }) => (light ? "#e57373" : " #80d8ff")};
  font-weight: bold;
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  margin-bottom: 10px;
`;
export const EducationCardSubTitle = styled.h4`
  font-size: 14px;
  color: ${({ light }) => (light ? " #9c9c9c" : " #bdbdbd")};
  margin-bottom: 10px;
  text-align: center;
`;

export const EducationCardSubTitleBorder = styled.h4`
  border-bottom: 2px solid #5dc1b9;
`;
export const EducationCardDesc = styled.p`
  margin-top: 10px;
  font-size: 13px;
  color: ${({ light }) => (light ? " white" : " #f7f8fa")};
`;
